<template>
  <div class="">
      <v-card class="neu-glow">
        <v-tabs
          color="info"
          class="pb-2"
          v-model="tab"
        >
          <v-tabs-slider color="info"></v-tabs-slider>
          <template v-for="(t,ti) in tabs" >
            <v-tab
              :key=ti
              :href="'#'+t.code"
              class="font-weight-bold"
            >
              {{t.name}}
            </v-tab>
            <v-tab-item :key=t :id="t.code" class="">
              <v-row class="mx-0">
                <component :is="t.code"></component>
              </v-row>
            </v-tab-item>
      </v-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { availableCountries  } from "@/config/countries";
import _ from 'lodash'
import invoices    from "./Invoices";
import cart        from "./AllModules";
export default {
    components: { invoices,cart},
  data() {
    return {
      page: "Account",
      wHeight: window.innerHeight,
      wWidth: window.innerWidth,
      printableItem:null,
      loading:false,
      tabs:[{name:'Fatture',code:'invoices'},{name:'Carrello',code:'cart'}],

    };
  },
  computed : {
    ...mapGetters(["settings"]),
  },
  beforeUnmount()
  {
      alert("leaving")
  },
  created(){
    //this.getData()

    //console.log(716,this.user);
    /*
    if (this.user&&this.user.username=='')
    {
      this.$router.push('/auth/login').catch(() => {});
    }
    else
    {
      this.getData()
    }*/
  },
  mounted(){
    //console.log(768,this.$route.query.user)
  },
  watch : {

  },
  methods:
  {
    async getData(origin)
    {
        {

            this.loading=true;
            try{
                const payload=JSON.stringify({"date": this.date,"action":"AllInvoices_get"});
                const res = await this.$http.post('/settings/settings.php', payload );
                console.log(275,res);
                this.loading=false;
                switch (res.data.errorid)
                {
                case '0':
                    sessionStorage.setItem('jwt', res.data.jwt);
                    this.items=res.data.payloads.allInvoices;
                    console.log(315,this.items)
                break;
                case '0006':
                    this.$router.push('/auth/login').catch(() => {});
                break;
                }
                this.loading= false;
            } catch(e)
            {
                this.loading= false;
                //console.log(res.data);
            }
        }
    },
    async updateDB(payload){
        try{
            const res = await this.$http.post('/settings/settings.php', payload);
            console.log(324,res);
            if (res.data.errorid=='0')
            {
            sessionStorage.setItem('jwt', res.data.jwt);
            this.snackbar_color='success';
            this.snackbar_message=res.data.message;

            if (res.data.message)
            {
                console.log(333);
                //this.snackbar=true;
            }
            }
            else
            {
              this.snackbar_color='error'
              this.snackbar_message=res.data.message;
              this.snackbar=true;
            console.log(342);
            //this.$router.push('/auth/login').catch(() => {});
            }

            //this.$store.dispatch("setUser", res.data.user); 
            return res.data;
        } catch(e)
        {
        console.log(e);
        }
    },
  },
};
</script>